import React, { useState, useEffect } from 'react';
import './navbar.css';
//import { useLocation } from "react-router-dom";
import axios from "axios";
//import DatePicker from "react-datepicker";
import {  Row, Col } from 'react-bootstrap';



const Classe_Form_Base = (props) => {

    const [variab_aggiorna, SET_variab_aggiorna] = useState('');
    const [end_Date, set_End_Date] = useState(new Date());
    const [input, setInput] = useState({
        nome: '',
        cognome: '',
        luogo_nascita: '',
        email: '',
        email_genitore: '',
        classe: '',
        corso: ''
    });


    useEffect(() => {
//        console.log('USEEFFECT alunno_form_base')
//        console.log(props.id)

        axios.get('/classi/trova_classe/' + props.id)
            .then((res) => {
//                console.log('domande appena fecciate da mongo')
                //                console.log(res.data)
                setInput(res.data)
//                console.log(res.data.nome)
                //                var dateObj = new Date(res.data.data_nascita);
                //                set_End_Date(dateObj)

            }).catch((error) => {
                console.log(error)
            });
    }, []);



    function handleChange(event) {
        const { name, value } = event.target;
        console.log('sssssss')

        console.log(end_Date)
        setInput(prevInput => {
            return {
                ...prevInput,
                [name]: value
            }
        })
    }


    function handleClick(event) {
        event.preventDefault();
        //        console.log(input);
        //        const new_alunno = {
        //            ...input,
        //            data_nascita: end_Date
        //        }
        //        console.log(new_alunno);
        //        axios.post('http://localhost:3001/create', newNote)
        axios.patch('/classi/classe_modifica/' + props.id, input)
            .then((res) => {
                console.log(res.data)
            }).catch((error) => {
                console.log(error)
            });
        props.setShow(false)
        //            variab_aggiorna = {variab_aggiorna} SET_variab_aggiorna={SET_variab_aggiorna}
    }

    return (
        <div>
            <div className='container'>
                <h2>Form Classe</h2>
                <form>
                    <div className='form-group'>
                        <p>

                            <span class="border border-primary">
                                <Row>
                                    <Col>
                                        <label>Nome</label>
                                        <input onChange={handleChange} placeholder="Nome" name="nome" value={input.nome} autoComplete="off" className="form-control"></input>
                                        <input onChange={handleChange} placeholder="Corso" name="corso" value={input.corso} autoComplete="off" className="form-control"></input>

                                    </Col>
                                 </Row>
                            </span>
                        </p>
                      
                  
      
                    </div>

                    <button onClick={handleClick} className="btn btn-lg btn-info">Salva</button>

                </form>
            </div>
        </div>
    );
}
export default Classe_Form_Base;